/*
 * @Description: 账户管理
 * @Date: 2025-05-19 17:59:57
 */

import { route } from './src/router';

const name = 'account';

export { name, route };
